import React, {Component, Fragment} from 'react';
import ValidatingPasswordInput from '../../../shared/components/form/ValidatingPasswordInput';
import LoadingButton from '../../../shared/ui/LoadingButton';
import defaultPropertiesUpdateFn from '../../models/form/defaultPropertiesUpdateFn';
import confirmValidationFn from '../../models/form/validation/confirm';
import newPasswordValidationFn from '../../models/form/validation/new-password';
import passwordValidationFn from '../../models/form/validation/password';

import '../../../public-app/components/Login.scss';
import {Auth} from "../../../shared/services/aws";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formErrors: null,
      formInfo: null,
      isTouched: false,
      properties: {
        confirmPassword: {
          isValid: false,
          name: 'confirmPassword',
          value: '',
        },
        password: {
          isValid: false,
          name: 'password',
          value: '',
        },
        newPassword: {
          isValid: false,
          name: 'newPassword',
          value: '',
        },
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // ----------------------
  // Computed
  // ----------------------

  get isFormValid() {
    return (
      this.state.isTouched &&
      !Object.keys(this.state.properties).find((key) => {
        return !this.state.properties[key].isValid;
      })
    );
  }

  // ----------------------
  // Methods
  // ----------------------

  catchNewPasswordError = (newPasswordError) => {
    // eslint-disable-next-line no-underscore-dangle
    switch (newPasswordError.name) {
      case 'InvalidParameterException':
      case 'InvalidPasswordException':
      case 'LimitExceededException':
        this.setState({
          formErrors: [{key: '0', message: newPasswordError.message}],
        });
        return null;
      case 'NotAuthorizedException':
        this.setState({
          formErrors: [{key: '0', message: 'Password incorrect.'}],
        });
        return null;
      default:
        this.setState({
          formErrors: [
            {key: '0', message: 'Unknown error setting new password.'},
          ],
        });
        return null;
    }
  };

  changePasswordSuccess = () => {
    this.setState({
      formErrors: [{key: '0', message: 'Your password has been changed.'}],
    });
  };

  handleChange(valueObject) {
    const callback = () => {
      if (!this.state.isTouched) {
        this.setState({isTouched: true});
      }
    };
    this.setState(
      defaultPropertiesUpdateFn(valueObject.name, valueObject),
      callback,
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      formErrors: null,
      formInfo: null,
    });
    const properties = {
      password: this.state.properties.password.value.trim(),
      newPassword: this.state.properties.newPassword.value.trim(),
    };

    Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(
          user,
          properties.password,
          properties.newPassword,
        );
      })
      .then(this.changePasswordSuccess)
      .catch(error => this.catchNewPasswordError(error));

  }

  // ----------------------
  // Render
  // ----------------------
  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Change Password</h4>
        </div>
        <div className="app-content login">
          {this.state.formErrors && (
            <div className="alert alert-danger">
              <ul className="mb-0 pl-3">
                {this.state.formErrors.map((error) => {
                  return <li key={error.key}>{error.message}</li>;
                })}
              </ul>
            </div>
          )}
          {this.state.formInfo && (
            <div className="alert alert-primary">
              <ul className="mb-0 pl-3">
                {this.state.formInfo.map((info) => {
                  return <li key={info.key}>{info.message}</li>;
                })}
              </ul>
            </div>
          )}
          <form noValidate onSubmit={event => this.handleSubmit(event)}>
            <ValidatingPasswordInput
              initialValue=""
              label="Password"
              onChange={this.handleChange}
              name="password"
              required
              validationFn={passwordValidationFn('Password', true)}
              value={this.state.properties.password.value}
            />
            <ValidatingPasswordInput
              initialValue=""
              label="New Password"
              onChange={this.handleChange}
              name="newPassword"
              required
              validationFn={newPasswordValidationFn('New Password', true)}
              value={this.state.properties.newPassword.value}
            />
            <ValidatingPasswordInput
              initialValue=""
              label="Confirm New Password"
              onChange={this.handleChange}
              name="confirmPassword"
              required
              validationFn={confirmValidationFn(
                'Confirm New Password',
                this.state.properties.newPassword.value,
                true,
              )}
              value={this.state.properties.confirmPassword.value}
            />
            <div className="text-right">
              <LoadingButton
                disabled={!this.isFormValid}
                isLoading={this.props.isLoading}
                primary
                text="Submit"
              />
            </div>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default ChangePassword;
